import constants from '@/common/constant'

export const SERVICE_NUMBER = constants.SERVICE_NUMBER

export function isEmpty(list) {
  return isNull(list) || list.length === 0
}

export function isNull(object) {
  return object === '' || object === null || typeof object === 'undefined'
}


//todo 全局 通用检查是不是移动环境
export const windowMatchMobile = ()=>{
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|ArkWeb|deviceType)/i
  )  // mobile环境
}
/**
 * todo 判断是不是 微信公众号内
 * @returns {boolean}
 */
export const wechatMatchMobile = ()=>{
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
}


/*
* 腾讯验证图
* success 成功后进行的操作
* loadingFailedFn js加载失败后进行的操作
*/ 
export const tencentVerification = (success = () => {},loadingFailedFn = () => {}) => {
  try {
    // 生成一个验证码对象
    const captcha = new TencentCaptcha("194520150",async (res) => {
      const {ticket, randstr, ret} = res
      // ret === 0 验证成功
      if (ret === 0){ 
        success(ticket, randstr)
      }

    }, {needFeedBack: false})
   
    // 调用方法，显示验证码
    captcha.show()
  } catch (error) {
 // 加载异常，调用验证码js加载错误处理函数
    loadingFailedFn()
  }
}